import './shared-libs';
// Anything exported from this file is importable by other in-browser modules.
export * from './iframeMode.utils';
export * from './sharedEnv';
export * from './sharedLang';
export * from './sharedApp';

const isSPA = true
export { isSPA };